import { Betreuerprovision } from 'api/betreuerprovision';
import moment from 'moment-timezone';

interface BetreuerAnteilPart {
    limit: number;
    provision: number;
    anteil: number;
}

interface BetreuerAnteil {
    value: number;
    parts: BetreuerAnteilPart[];
}

export function getBetreuerAnteil(
    betreuerprovisionListByNr: { [key: number]: Betreuerprovision[] },
    betreuerNr: number,
    date: string,
    nMarge: number,
    currentBetreuerAnteil: number,
): BetreuerAnteil {
    const parts: BetreuerAnteilPart[] = [];

    const betreuerprovisionList = betreuerprovisionListByNr[betreuerNr];
    if (!betreuerprovisionList || betreuerprovisionList.length === 0) {
        return { value: 0, parts };
    }

    let betreuerprovision: Betreuerprovision = betreuerprovisionList[0];
    betreuerprovisionList.forEach((bp) => {
        if (moment(bp.abDat).isBefore(date)) {
            betreuerprovision = bp;
        }
    });

    if (!betreuerprovision) {
        return { value: 0, parts };
    }

    // prov1

    let nMarge2 = nMarge;
    let newBetreuerAnteil = 0;
    if (betreuerprovision.provWert1 === 0) {
        const provision = betreuerprovision.prov1 || betreuerprovision.provision;
        newBetreuerAnteil = (nMarge2 / 100) * provision;

        parts.push({
            limit: 0,
            provision,
            anteil: newBetreuerAnteil - currentBetreuerAnteil,
        });

        return { value: newBetreuerAnteil - currentBetreuerAnteil, parts };
    }

    newBetreuerAnteil =
        ((betreuerprovision.provWert1 === 0 ? nMarge2 : Math.min(nMarge2, betreuerprovision.provWert1)) / 100) *
        betreuerprovision.prov1;

    parts.push({
        limit: betreuerprovision.provWert1,
        provision: betreuerprovision.prov1,
        anteil: newBetreuerAnteil - currentBetreuerAnteil,
    });

    if (nMarge2 <= betreuerprovision.provWert1) {
        return { value: newBetreuerAnteil - currentBetreuerAnteil, parts };
    }

    // prov2

    nMarge2 -= betreuerprovision.provWert1;

    if (betreuerprovision.provWert2 === 0) {
        newBetreuerAnteil = (nMarge2 / 100) * betreuerprovision.prov2;
        return { value: newBetreuerAnteil - currentBetreuerAnteil, parts };
    }

    const prov2MaxValue = betreuerprovision.provWert2 - betreuerprovision.provWert1;

    newBetreuerAnteil += (Math.min(nMarge2, prov2MaxValue) / 100) * betreuerprovision.prov2;

    parts.push({
        limit: betreuerprovision.provWert2,
        provision: betreuerprovision.prov2,
        anteil: newBetreuerAnteil - currentBetreuerAnteil,
    });

    if (nMarge2 <= prov2MaxValue) {
        return { value: newBetreuerAnteil - currentBetreuerAnteil, parts };
    }

    // prov3

    nMarge2 -= prov2MaxValue;

    if (betreuerprovision.provWert3 === 0) {
        newBetreuerAnteil = (nMarge2 / 100) * betreuerprovision.prov3;
        return { value: newBetreuerAnteil - currentBetreuerAnteil, parts };
    }

    const prov3MaxValue = betreuerprovision.provWert3 - betreuerprovision.provWert2;

    newBetreuerAnteil += (Math.min(nMarge2, prov3MaxValue) / 100) * betreuerprovision.prov3;

    parts.push({
        limit: betreuerprovision.provWert3,
        provision: betreuerprovision.prov3,
        anteil: newBetreuerAnteil - currentBetreuerAnteil,
    });

    if (nMarge2 <= prov3MaxValue) {
        return { value: newBetreuerAnteil - currentBetreuerAnteil, parts };
    }

    // prov4

    nMarge2 -= prov3MaxValue;
    newBetreuerAnteil += (nMarge2 / 100) * betreuerprovision.prov4;

    parts.push({
        limit: betreuerprovision.provWert4,
        provision: betreuerprovision.prov4,
        anteil: newBetreuerAnteil - currentBetreuerAnteil,
    });

    return { value: newBetreuerAnteil - currentBetreuerAnteil, parts };
}
